import ContinueRedirect from "@khan/component-screens/continue-redirect";

export default function AppContinueRedirect() {
    return <ContinueRedirect />;
}
